import PropTypes from 'prop-types';
import { Field as ReduxFormField } from 'redux-form';
import { Field as FinalFormField } from 'react-final-form';
import Control from '../Control';

export default function Field({ isReactFinalForm = false, ...props }) {
  const FormField = isReactFinalForm ? FinalFormField : ReduxFormField;

  return <FormField {...props} component={Control} />;
}

Field.propTypes = {
  isReactFinalForm: PropTypes.bool,
};
